import '../sass/style.scss';
import $ from 'jquery';
window.$ = $;

import useragent from './util/useragent.js';
import Swiper from 'swiper/bundle';
window.Swiper = Swiper;
import ScrollMagic from 'scrollmagic';
window.ScrollMagic = ScrollMagic;
import ScrollFade from './util/scroll-fade';
import Parallax from './util/parallax';
import Anchor from './util/anchor';
import GetQueryParam from './util/get-query-param';

import HomeController from './controller/home-controller';
import MagazineController from './controller/magazine-controller';
import PlannersInterviewController from './controller/planners-interview-controller';
import QuestionnaireController from './controller/questionnaire-controller';
import SustainabilityController from './controller/sustainability-controller';
import WellnessController from './controller/wellness-controller';
import StyleDetailController from './controller/style-detail-controller';
import AfterclubController from './controller/afterclub-controller';
import FaqController from './controller/faq-controller';
import ShowroomController from './controller/showroom-controller';
import DclassoController from './controller/dclasso-controller';
import MovieController from './controller/movie-controller';
import IotController from './controller/iot-controller';
import IotHousingController from './controller/iot-housing-controller';
import NewnormalController from './controller/newnormal-controller';
import DisasterController from './controller/disaster-controller';
import WellController from './controller/well-controller';
import EthicalController from './controller/ethical-controller';
import ContactController from './controller/contact-controller';
import ValidatorController from "./controller/validator-controller";
import OwnersVoiceController from "./controller/ownersvoice-controller";
import OwnersvoiceDetailController from "./controller/ownersvoice-detail-controller";
import ArisePremium25Controller from './controller/arise-premium25-controller.js';
class App {
    constructor() {
        window.UA = useragent;
        window.UA.event();

        $(document).ready(() => {
            new ScrollFade();
            new Parallax();

            this.load();
            this.AddSpCatalog();
            this.setGlobalMenu();
            this.setGlobalAbout();
            this.setSPFooterToggle();
            this.setSPHeaderToggle();
            this.createIndex();
            this.setPopup();
            this.setHeaderChange();
            this.setMenuBottomSPVisible();
            this.setSPMoreToggle();
            this.setSPBreadScroll();
            if (!window.UA.isSP) {
                this.setPCFooterBanner();
            }
        });
    }

    AddSpCatalog() {
        let $mvbanner = $('.global-footer__catalog .mainvisual__banner').html();
        $('#js-mainvisual__banner').append($mvbanner);

        let $wrapper = $('.global-footer__catalog .mainvisual__banner');
        let $btn = $('.global-footer__catalog .mainvisual__banner-btn');
        $btn.on('click', function () {
            $wrapper.toggleClass('is-open');
        });
    }

    load() {
        let $container = $('#js-container');

        if ($container.hasClass('is-home')) {
            new HomeController();
        }
        if ($container.hasClass('is-magazine')) {
            new MagazineController();
        }
        if ($container.hasClass('is-planners_interview')) {
            new PlannersInterviewController();
        }
        if ($container.hasClass('is-questionnaire')) {
            new QuestionnaireController();
        }
        if ($container.hasClass('is-sustainability')) {
            new SustainabilityController();
        }
        if ($container.hasClass('is-wellness')) {
            new WellnessController();
        }
        if ($container.hasClass('is-style-detail')) {
            new StyleDetailController();
        }
        if ($container.hasClass('is-afterclub')) {
            new AfterclubController();
        }
        if ($container.hasClass('is-faq')) {
            new FaqController();
        }
        if ($container.hasClass('is-showroom')) {
            new ShowroomController();
        }
        if ($container.hasClass('is-d-classo')) {
            new DclassoController();
        }
        if ($container.hasClass('is-movie')) {
            new MovieController();
        }
        if ($container.hasClass('is-iot')) {
            new IotController();
        }
        if ($container.hasClass('is-iot-housing')) {
            new IotHousingController();
        }
        if ($container.hasClass('is-newnormal')) {
            new NewnormalController();
        }
        if ($container.hasClass('is-disaster')) {
            new DisasterController();
        }
        if ($container.hasClass('is-well')) {
            new WellController();
        }
        if ($container.hasClass('is-ethical')) {
            new EthicalController();
        }
        if ($container.hasClass('is-ownersvoice')) {
            new OwnersVoiceController();
        }
        if ($container.hasClass('is-ownersvoice-detail')) {
            new OwnersvoiceDetailController();
        }
        if ($container.hasClass('is-contact')) {
            new ContactController();
            if (! $container.hasClass('confirm')) {
                new ValidatorController();
            }
        }
        if ($container.hasClass('is-arisepremium')) {
            new ArisePremium25Controller();
        }
        
    }

    setGlobalMenu() {
        let $btn = $('#js-global-header__btn');
        let $header = $('#js-global-header');
        let $menu = $('#js-global-header__menu');

        let $menuPC = $('#js-global-header__menu-pc');
        let $menuPCBtn = $('#js-global-header__menu-pc-btn');
        let $overlay = $('.global-header__bg');
        let $wrapper = $('.global-header__menu-pc-content-wrapper');
        if (window.UA.isSP) {
            $btn.on('click', function (e) {
                e.preventDefault();
                $header.toggleClass('is-open');
                $menu.toggleClass('is-open');
                $overlay.toggleClass('is-overlay');
                $('body').toggleClass('is-scrollLock');
            });
        } else {
            $btn.on('click', function (e) {
                e.preventDefault();
                $menuPC.addClass('is-open');
                $wrapper.animate({
                    scrollTop: 0
                },16);
                $('body').addClass('is-scrollLock');
            });
            $menuPCBtn.on('click', function (e) {
                e.preventDefault();
                $menuPC.removeClass('is-open');
                $('body').removeClass('is-scrollLock');
            });
        }
    }

    setGlobalAbout() {
        let $btn = $('.js-about-index__btn');
        let $close = $('.js-about-index__close');
        let $content = $('#js-about-index__content');

        setTimeout(function () {
            $content.css('display', 'block');
        }, 500);

        $btn.on('click', function (e) {
            e.preventDefault();
            $content.addClass('is-open');
            $('body').addClass('is-scrollLock');
        });
        $close.on('click', function (e) {
            e.preventDefault();
            $content.removeClass('is-open');
            $('body').removeClass('is-scrollLock');
        });
    }

    setPCFooterBanner() {
        let $a = $('#js-global-footer__nav-link a');
        let $bg = $('#js-global-footer__nav-bg .global-footer__nav-bg-img');
        $a.on('mouseenter', function () {
            let $this = $(this);
            let target = $this.data('target');
            $bg.removeClass('is-show');
            $(`.global-footer__nav-bg-img.${target}`).addClass('is-show');
        });
        $a.on('mouseleave', function () {
            $bg.removeClass('is-show');
        });
    }

    setSPFooterToggle() {
        let $a = $('.global-footer__sitemap-item-primary');
        if (window.UA.isSP) {
            let $children = $('.global-footer__sitemap-item-children');

            $children.slideUp(16);
            $a.each(function () {
                let $this = $(this);
                $this.on('click', function (e) {
                    e.preventDefault();
                    $this
                        .find('.global-footer__sitemap-item-primary-sptriiger')
                        .toggleClass('is-open');
                    $this
                        .next('.global-footer__sitemap-item-children')
                        .slideToggle(250);
                });
            });
        } else {
            $a.each(function () {
                let $this = $(this);
                $this.on('click', function (e) {
                    e.preventDefault();
                    return false;
                });
            });
        }
    }

    setSPHeaderToggle() {
        let $a = $('.global-header__menu-sitemap-item-primary');
        if (window.UA.isSP) {
            let $children = $('.global-footer__sitemap-item-children');

            $children.slideUp(16);
            $a.each(function () {
                let $this = $(this);
                $this.on('click', function (e) {
                    e.preventDefault();
                    $this
                        .find('.global-footer__sitemap-item-primary-sptriiger')
                        .toggleClass('is-open');
                    $this
                        .next('.global-footer__sitemap-item-children')
                        .slideToggle(250);
                });
            });
            $(document).ready(function () {
                $('.global-footer__sitemap-item-children a').each(function () {
                    if ($(this).hasClass('is-current')) {
                        $(this)
                            .parents('.global-footer__sitemap-item-children')
                            .slideDown(16);
                        $(this)
                            .parents('.global-footer__sitemap-item-children')
                            .prev('.global-header__menu-sitemap-item-primary')
                            .find(
                                '.global-footer__sitemap-item-primary-sptriiger'
                            )
                            .addClass('is-open');
                    }
                });
            });
        } else {
            $a.each(function () {
                let $this = $(this);
                $this.on('click', function (e) {
                    e.preventDefault();
                    return false;
                });
            });
        }
    }

    createIndex() {
        let $index = $('#js-column-detail__index-items');
        let $content = $('.magazine-detail__content, .ownersvoice-detail__content');
        let $titles = $content.find('h2, h3');
        if ($titles.length < 1) {
            $('.column-detail__index').hide();
        }
        let html = '';
        //     <a href="#sec2">
        //     <span>タイトルタイトルタイトルタイトルタイトル</span>
        // </a>
        $titles.each(function (i, elm) {
            let $this = $(this);
            let id = `sec${i}`;
            $this.attr('id', id);
            let node = $this.prop('nodeName');
            let className = 'is-h2';
            // console.log($this.prop('nodeName'));
            if (node === 'H3') {
                className = 'is-h3';
            }
            html =
                html +
                `<a href="#${id}" class="${className}"><span>${$this.text()}</span></a>`;
        });
        $index.append(html);
        new Anchor();
    }

    setPopup() {
        let $popup = $('.popup');
        let $close = $('.popup__close');
        $popup.each(function () {
            let $this = $(this);
            let trigger = $this.data('trigger');
            $(`#${trigger}`).on('click', function (e) {
                e.preventDefault();
                $this.addClass('is-open');
            });
        });
        $close.on('click', function (e) {
            e.preventDefault();
            $popup.removeClass('is-open');
        });
        $popup.on('click', function (e) {
            e.preventDefault();
            // console.log(e.target);
            if (
                $(e.target).hasClass == 'popup' ||
                $(e.target).hasClass == 'popup__nav'
            ) {
                $popup.removeClass('is-open');
            }
        });

        let q = new GetQueryParam();
        // console.log(q);
        if (q.madori) {
            // console.log(1);
            $('#js-planners_interview-detail__madori-zoom').trigger('click');
        }
    }

    setHeaderChange() {
        let $section = document.querySelectorAll('.js-header-change-trigger');
        if ($section.length === null) {
            return;
        }
        let controller = new ScrollMagic.Controller();
        // window.scrollController.push(controller);
        for (let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: 'onEnter',
                reverse: true,
                offset: window.innerHeight,
            })
                //.addIndicators({name: '____HRERE333'}) // add indicators (requires plugin)
                .addTo(controller);
            scene.on('enter', () => {
                let className = $($section[i]).data('header');
                $('#js-global-header').addClass(className);
            });
            scene.on('leave', () => {
                let className = $($section[i]).data('header');
                $('#js-global-header').removeClass(className);
            });
        }
    }

    setMenuBottomSPVisible() {
        let $menuBottom = $('#js-global-header__menu-bottom');
        let $footer = $('.global-footer');
        let lastScrollTop = 0;
        let timeoutId;

        $(window).scroll(function () {
            let currentScrollTop = $(this).scrollTop();
            let footerOffset = $footer.offset().top;

            if (currentScrollTop + $(this).height() >= footerOffset) {
                $menuBottom.removeClass('is-visible');
            } else if (currentScrollTop < lastScrollTop) {
                $menuBottom.addClass('is-visible');
            } else {
                $menuBottom.removeClass('is-visible');
            }

            lastScrollTop = currentScrollTop;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(function () {
                $menuBottom.addClass('is-visible');
            }, 300);
        });
    }

    setSPMoreToggle() {
        let $a = $('.js-toggle-more');
        if (window.UA.isSP) {
            $a.each(function () {
                let $this = $(this);
                let target = $this.data('target');
                let height = $(`#${target}`).height();

                let $items = $(`#${target}`).find(
                    '.style-detail__facility-kitchen-item'
                );
                let beforeheight = 0;
                $items.each(function (i) {
                    beforeheight = beforeheight + $(this).height() + 30;
                    // console.log(i, $(this).height());
                    if (i > 1) {
                        return false;
                    }
                });
                $(`#${target}`).css({
                    maxHeight: `${beforeheight}px`,
                });

                $this.on('click', function (e) {
                    e.preventDefault();
                    $(`#${target}`).css({
                        maxHeight: height,
                    });
                    $this
                        .parent('.style-detail__facility-kitchen-more')
                        .addClass('is-close');
                });
            });
        }
    }

    setSPBreadScroll() {
        if ($('.magazine-detail__inner').length > 0) {
            $('.breadcrumb__inner').addClass('has-sp-scroll');
        }
        $('.breadcrumb').addClass('is-show');
    }
}

new App();
